export const delimiter = '.';
